import type { RouteConfig } from 'vue-router';

export default [
  // 还款列表重定向到还款账单
  {
    path: '/repayment',
    redirect: '/repayment/bill',
  },
  // 还款计划列表重定向到还款账单
  {
    path: '/repayment/plan',
    redirect: '/repayment/bill',
  },
  /**
   * 我的还款账单
   */
  {
    path: '/repayment/bill',
    meta: {
      title: '我的账单',
      excludeTracking: true,
      customNavBar: true,
    },
    component: () => import('@/views/repayment/bill/index.vue'),
  },
  /**
   * 我的还款账单-详情
   */
  {
    path: '/repayment/bill/detail',
    meta: {
      title: '账单详情',
      background: '#F6F7FB',
      customNavBar: true,
      excludeTracking: true,
    },
    component: () => import('@/views/repayment/bill/detail.vue'),
  },
  /**
   * 原账单详情页路径参数转换成query参数
   */
  {
    path: '/repayment/bill/:applyId',
    beforeEnter(to, from, next) {
      next({
        path: '/repayment/bill/detail',
        query: {
          ...to.query,
          applyId: to.params.applyId,
        },
        hash: to.hash,
        replace: true,
      });
    },
  },
  /**
   * 主动支付
   * 指定?type=1则进入一次性结清还款
   */
  {
    path: '/repayment/cashier',
    meta: {
      title: '支付',
      customNavBar: true,
      excludeTracking: true,
    },
    component: () => import('@/views/repayment/cashier.vue'),
  },
  /**
   * 原支付页路径参数转换成query参数
   */
  {
    path: '/repayment/cashier/:applyId',
    beforeEnter(to, from, next) {
      next({
        path: '/repayment/cashier',
        query: {
          ...to.query,
          applyId: to.params.applyId,
        },
        hash: to.hash,
        replace: true,
      });
    },
  },
  /**
   * 原支付结果页路径参数转换为query参数
   */
  {
    path: '/repayment/result/:paymentId',
    beforeEnter(to, from, next) {
      next({
        path: '/repayment/result',
        query: {
          ...to.query,
          paymentId: to.params.paymentId,
        },
        hash: to.hash,
        replace: true,
      });
    },
  },
  /**
   * 支付结果
   */
  {
    path: '/repayment/result',
    meta: {
      title: '支付结果',
      excludeTracking: true,
      background: '#fff',
    },
    component: () => import('@/views/repayment/result.vue'),
  },
  /**
   * 对公还款
   */
  {
    path: '/repayment/public/account',
    meta: {
      title: '支付',
    },
    component: () => import('@/views/repayment/public-repayment/account.vue'),
  },
  /**
   * 对公还款-信息登记
   */
  {
    path: '/repayment/public/customer-information',
    meta: {
      title: '支付',
    },
    component: () => import('@/views/repayment/public-repayment/customer-information.vue'),
  },
  /**
   * 重新绑卡列表
   */
  {
    path: '/repayment/rebind',
    meta: {
      title: '宜享花',
      background: '#F5F6FA',
      customNavBar: true,
    },
    component: () => import('@/views/repayment/rebind-card.vue'),
  },
  /**
   * 支付宝还款（代偿）
   */
  {
    path: '/repayment/compensatory',
    meta: {
      excludeLogin: true,
    },
    component: () => import('@/views/repayment/compensatory.vue'),
  },
  /**
   * 支付宝还款结果页（代偿）
   */
  {
    path: '/repayment/compensatory-result',
    meta: {
      excludeLogin: true,
    },
    component: () => import('@/views/repayment/compensatory-result.vue'),
  },
] as RouteConfig[];
